export default "__VITE_ASSET__CgDlfL5o__"